var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdtTrx({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 27,
    viewBox: "0 0 32 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1161_14649",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 27
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V26.1528H32V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1161_14649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0764 25.8339C20.125 25.8339 25.8339 20.125 25.8339 13.0764C25.8339 6.02794 20.125 0.31897 13.0764 0.31897C6.02794 0.31897 0.31897 6.02794 0.31897 13.0764C0.31897 20.125 6.02794 25.8339 13.0764 25.8339Z",
    fill: "#26A17B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6393 13.9588C14.5542 13.9588 14.0971 13.9907 13.0871 13.9907C12.2791 13.9907 11.7157 13.9694 11.5137 13.9588C8.40936 13.8206 6.10238 13.2784 6.10238 12.6405C6.10238 12.0026 8.41999 11.4604 11.5137 11.3116V13.4166C11.7157 13.4272 12.3004 13.4697 13.0977 13.4697C14.0652 13.4697 14.5436 13.4272 14.6286 13.4272V11.3222C17.7223 11.4604 20.0293 12.0026 20.0293 12.6405C20.0399 13.2784 17.7329 13.8206 14.6393 13.9588ZM14.6393 11.099V9.20661H18.9555V6.33618H7.20803V9.21724H11.5243V11.099C8.016 11.2584 5.37946 11.9601 5.37946 12.7893C5.37946 13.6186 8.016 14.3202 11.5243 14.4797V20.5182H14.6393V14.4691C18.1369 14.3096 20.7735 13.6186 20.7735 12.7787C20.7735 11.9388 18.1476 11.2584 14.6393 11.099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5581 20.5182C28.6724 20.5182 32 17.1907 32 13.0764C32 8.9621 28.6724 5.63452 24.5581 5.63452C20.4438 5.63452 17.1163 8.9621 17.1163 13.0764C17.1163 17.1907 20.4438 20.5182 24.5581 20.5182Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5582 20.1993C28.4917 20.1993 31.6811 17.01 31.6811 13.0764C31.6811 9.14286 28.4917 5.95349 24.5582 5.95349C20.6246 5.95349 17.4352 9.14286 17.4352 13.0764C17.4352 17.01 20.6246 20.1993 24.5582 20.1993Z",
    fill: "#EF0027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9396 10.3549L20.5183 9.1748L23.899 17.6798L28.6087 11.9389L26.9396 10.3549ZM26.8333 10.8758L27.8113 11.8113L25.1216 12.3004L26.8333 10.8758ZM24.5475 12.1941L21.7196 9.84457L26.3549 10.6951L24.5475 12.1941ZM24.3456 12.6193L23.8884 16.4359L21.4007 10.1635L24.3456 12.6193ZM24.7708 12.8213L27.7475 12.2791L24.3349 16.4359L24.7708 12.8213Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdtTrx);
export default __webpack_public_path__ + "static/media/usdt_trx.184824f73f7f96e4fc11cfd276076863.svg";
export { ForwardRef as ReactComponent };